import React, { useState } from 'react'
import { I18n } from 'react-redux-i18n'

import Tab from './Tab'
import ServiceAPI from './ServiceAPI'
import ActivityAPI from './ActivityAPI'

/**
 * Container app info
 * @param {object} props
 * @param {object} props.app
 * @param {function} props.setApp
 *
 * @returns {React.Component}
 */
const ContainerAPPInfo = (props) => {
  const { app, setApp } = props

  const [tabSelected, setTabSelected] = useState('service_api')

  return (
    <div className='integrations-app-edit__scopes'>
      <div className='integrations-app-edit__title'>
        {I18n.t('integration_app_edit_scope_title')}
      </div>

      <div className='integrations-app-edit__info'>
        {I18n.t('integration_app_scope_info')}
      </div>

      <div className='integrations-app-edit__scopes-container'>
        <div className='integrations-app-edit__scopes-tabs'>
          <Tab
            name='service_api'
            title={I18n.t('integration_app_edit_scope_tab_service_api')}
            value={tabSelected}
            onClick={setTabSelected}
          />
          <Tab
            name='activity_api'
            title={I18n.t('integration_app_edit_scope_tab_activity_api')}
            value={tabSelected}
            onClick={setTabSelected}
          />
        </div>
        <div className='integrations-app-edit__scopes-content'>
          {
            tabSelected === 'service_api'
              ? (
                <ServiceAPI
                  app={app}
                  setApp={setApp}
                />
              )
              : (
                <ActivityAPI
                  app={app}
                  setApp={setApp}
                />
              )
          }
        </div>
      </div>
    </div>
  )
}

export default ContainerAPPInfo
